import React from 'react';

/**
 * Car Step Icon - Used in Cars page.
 */
export const ServiceSplitIcon = ({ size = 46 }: { size?: number }): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={(44 / 46) * size} height={size} viewBox="0 0 44 46" fill="none">
      <path d="M43 9H12V5H43C43.5523 5 44 5.44772 44 6V8C44 8.55229 43.5523 9 43 9Z" fill="#D9E0E9" />
      <path d="M23 5H19V9H23V5Z" fill="#A0AFBD" />
      <path d="M43 41H12V37H43C43.5523 37 44 37.4477 44 38V40C44 40.5523 43.5523 41 43 41Z" fill="#D9E0E9" />
      <path d="M23 37H19V41H23V37Z" fill="#A0AFBD" />
      <path d="M43 25H30V21H43C43.5523 21 44 21.4477 44 22V24C44 24.5523 43.5523 25 43 25Z" fill="#D9E0E9" />
      <path d="M41 21H37V25H41V21Z" fill="#A0AFBD" />
      <path d="M12 9H1C0.44772 9 0 8.55229 0 8V6C0 5.44772 0.44772 5 1 5H12V9Z" fill="#FF3975" />
      <path d="M30 25H1C0.44772 25 0 24.5523 0 24V22C0 21.4477 0.44772 21 1 21H30V25Z" fill="#FF3975" />
      <path d="M12 41H1C0.44772 41 0 40.5523 0 40V38C0 37.4477 0.44772 37 1 37H12V41Z" fill="#FF3975" />
      <path
        d="M13 14C16.866 14 20 10.866 20 7C20 3.13401 16.866 0 13 0C9.13401 0 6 3.13401 6 7C6 10.866 9.13401 14 13 14Z"
        fill="#EFF3F7"
      />
      <path
        d="M31 30C34.866 30 38 26.866 38 23C38 19.134 34.866 16 31 16C27.134 16 24 19.134 24 23C24 26.866 27.134 30 31 30Z"
        fill="#EFF3F7"
      />
      <path
        d="M13 46C16.866 46 20 42.866 20 39C20 35.134 16.866 32 13 32C9.13401 32 6 35.134 6 39C6 42.866 9.13401 46 13 46Z"
        fill="#EFF3F7"
      />
    </svg>
  );
};
